// extracted by mini-css-extract-plugin
module.exports = {"container":"DatePicker_container__2JnGy","placeholder":"DatePicker_placeholder__1yl00","arrow":"DatePicker_arrow__30Xoo","open":"DatePicker_open__23lSo"};